// Runtime środowiska po stronie klienta — wykrywane z hostname przeglądarki.
// Świadomie NIE używamy env vara (VITE_*/SSM/Terraform): host produkcyjny jest
// stały i znany, więc gating po hostname nie wymaga zmian w infrze.

// Kanoniczny host produkcyjnej aplikacji (FRONTEND_URL w .replit / prod ECS).
const PRODUCTION_HOST = "app.viral.partners";

/**
 * Czy aplikacja działa na produkcyjnym hoście.
 * Wszystko inne (dev deploy, localhost) traktujemy jako nie-prod.
 */
export function isProductionHost(): boolean {
  if (typeof window === "undefined") return false;
  return window.location.hostname === PRODUCTION_HOST;
}
